#search-widget {
  position: relative;
  color: $c11n-color-ink-800;
  font-family: $c11n-font-family-sans;
  width: 100%;

  .search-on-nav {
    cursor: pointer;
  }

  @include media-breakpoint-down(lg) {
    .modal-overlay-bg {
      position: fixed;
      inset: 0;
      background: rgb(0 0 0 / 40%);
      z-index: 1;
    }
  }

  .search-widget-container {
    position: relative;
    top: 0;
    right: 0;
    z-index: 10;
    width: 100%;

    .search-input-container {
      position: relative;
      display: flex;
      box-sizing: content-box;
      background-color: #fff;
      width: 100%;


      button {
        cursor: pointer;
      }

      .back-button {
        display: inline-block;
        position: absolute;
        top: 1rem;
        left: 20px;
        z-index: 2;
        padding: 9px;
        background: transparent;
        border: none;
      }

      .search-button {
        display: none;
      }

      @include media-breakpoint-up(lg) {
        .back-button {
          display: none;
        }

        .search-button {
          display: inline-block;
        }
      }
    }
  }

  @include media-breakpoint-down(lg) {
    .search-on-nav {
      position: absolute;
      right: 0;
    }

    .search-widget-container {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;

      .search-input-container {
        .back-button {
          padding-top: 13px;
        }

        width: 100%;

        .c11n-search {
          .c11n-search__form__input-row__input {
            width: 100%;

            .c11n-input__input {
              border: none;
              height: auto;
              padding: 24px 53px;
            }

            .c11n-search__form__input-row__input__clear {
              right: 22px;
            }
          }

          .c11n-search__form__submit {
            display: none;
          }
        }
      }
    }
  }
}